<template>
  <vs-popup class="user-edit-popup"
            id="popup"
            title="SUPPLIER ORGANIZATION DETAILS"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                <small class="label">Company Name</small>
                <vs-input readonly v-model="createForm.company_name"   name="company_name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="telephone" name="telephone" rules="required|contactNumber|min_tel|max_tel" v-slot="{ errors }">
                <small class="label">Telephone</small>
                <vs-input readonly  v-model="createForm.telephone" class="w-full"  name="telephone" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="fax" name="fax" rules="" v-slot="{ errors }">
                <small class="label">Fax</small>
                <vs-input readonly v-model="createForm.fax"   name="fax" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-input readonly  v-model="createForm.note" class="w-full"  name="note" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sedex_no" name="sedex_no" rules="" v-slot="{ errors }">
                <small class="label">Sedex No</small>
                <vs-input readonly v-model="createForm.sedex_no" name="sedex_no" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="vat_registration" name="vat_registration" rules="" v-slot="{ errors }">
                <small class="label">VAT Registration</small>
                <vs-input readonly  v-model="createForm.vat_registration" class="w-full"  name="vat_registration" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="registration" name="registration" rules="" v-slot="{ errors }">
                <small class="label">Registration</small>
                <vs-input readonly v-model="createForm.registration"   name="registration" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="mobile" name="mobile" rules="" v-slot="{ errors }">
                <small class="label">Registration</small>
                <vs-input readonly v-model="createForm.mobile"   name="mobile" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">-->
<!--                <small class="label">Email</small>-->
<!--                <vs-input v-model="createForm.email"   name="email" class="w-full required" label=""/>-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
          <!-- Save & Reset Button -->
<!--          <div class="flex flex-wrap items-center justify-end mt-8">-->
<!--            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>-->
<!--            <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
<!--          </div>-->
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      createForm: {}
    }
  }

export default {
  name: 'ViewSupplierPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        this.id = id;
        this.getSupplier()
      } catch (error) {

      }
    },
    async getSupplier() {
      this.$vs.loading()
      const {data} = (await SupplierRepository.getSupplier(this.id)).data
      this.createForm = data
      this.$vs.loading.close()
    },
    async onClickCreateStaffUser (){
      const vue = this;
      this.$vs.loading()
       try {
         await SupplierRepository.updateSupplier(this.id, this.createForm)
         this.showSuccessMessage('supplier updated successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
